import userData from './user-data';
import userPreferences from './user-preferences';

export default {
  userData,
  userPreferences,
};
